"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventBus = require("@/helpers/event-bus.js");

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Synthse',
  data: function data() {
    return {
      CONST: CONST,
      refresh: 0,
      totaux: [],
      data: [],
      dataMmoins1: [],
      avenantMarchePrincipal: [],
      dataSave: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    _eventBus.EventBus.$on('REFRESH', function () {
      _this.data = _this.$store.getters.affaire.calculs.affaire;
      _this.dataMmoins1 = _this.$store.getters.affaire.calculsMmoins1;
      _this.totaux = _this.$store.getters.affaire.calculs.affaire;
      _this.avenantMarchePrincipal = _this.$store.getters.affaire.calculs.avenantsMarchePrincipalEntetes;
      _this.gestmensAffaire = _this.$store.getters.affaire.gestmensAffaire.filter(function (x) {
        return x.anneemois === _this.data.YYYYMM;
      })[0] || [];
    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH');
  },
  computed: {
    currentYYYYMM: function currentYYYYMM() {
      return (0, _moment.default)().format('YYYYMM');
    },

    /*
    mtMoisFacturationClient () {
      return this.data.mtFacturationClient || 0
    },
    mtMoisFactureMerite () {
      const pv = this.dataMmoins1.mtPmPrixDeVente || 0
      return this.data.mtPmPrixDeVente - pv
    }
    */
    mtMoisFacturationClient: function mtMoisFacturationClient() {
      // return this.data.mtFacturationClient || 0
      var mt = this.dataMmoins1.mtCumulFacturationClientM || 0;
      return this.data.mtCumulFacturationClientM - mt;
    },
    mtMoisFactureMerite: function mtMoisFactureMerite() {
      var pv = this.dataMmoins1.mtPmPrixDeVente || 0;
      return this.data.mtPmPrixDeVente - pv;
    },
    mtCumulFacturationClientMmoins1: function mtCumulFacturationClientMmoins1() {
      return this.dataMmoins1.mtCumulFacturationClientM || 0;
    },
    mtPmPrixDeVenteMmoins1: function mtPmPrixDeVenteMmoins1() {
      return this.dataMmoins1.mtPmPrixDeVente || 0;
    }
  }
};
exports.default = _default;